/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'

import { Controller, useForm } from 'react-hook-form'
import { useMutation, useQuery } from '@apollo/client'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import formStyles from '@assets/scss/components/form.module.scss'
import { TOAST_TYPE, EMAIL, ONLY_NUMBER } from '@shared-submodule/sm-constants'
import { validationErrors } from '@shared/constants/ValidationErrors'
import { GET_CONTACT_QUERY_TYPE, INSERT_CONTACT } from '@graphql/cms/cms.query'
import ToastrContext from '@shared/components/toastr/ToastrContext'

const Layout = dynamic(() => import('@shared/components/layout'))
const CustomFormGroup = dynamic(() => import('@shared/components/customForm/customFormGroup'))
const CustomInput = dynamic(() => import('@shared/components/customForm/customInput'))
const CustomFeedback = dynamic(() => import('@shared/components/customForm/customFeedback'))
const CustomSelect = dynamic(() => import('@shared/components/customSelect'), { ssr: false })

const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })

const ContactUs = ({ seoData }) => {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors }
  } = useForm({ mode: 'onTouched' })
  const { dispatch } = useContext(ToastrContext)
  const router = useRouter()
  const [typeOfQueryOptions, setTypeOfQueryOptions] = useState()

  useQuery(GET_CONTACT_QUERY_TYPE, {
    onCompleted: data => {
      if (data && data.getContactQueryType) {
        setTypeOfQueryOptions(data.getContactQueryType)
      }
    }
  })

  const [insertContact, { loading }] = useMutation(INSERT_CONTACT, {
    onCompleted: data => {
      if (data && data?.insertContact) {
        dispatch({
          type: 'SHOW_TOAST',
          payload: { message: data.insertContact?.sMessage, type: TOAST_TYPE.Success }
        })
        router.push('/')
      }
    }
  })

  function onSubmit(formData) {
    const data = { ...formData, eQueryType: 'g' }
    insertContact({ variables: { input: { contactInput: data } } })
    // dispatch({
    //   type: 'SHOW_TOAST',
    //   payload: { message: 'Thank you for contacting us!', type: TOAST_TYPE.Success }
    // })
    // router.push('/')
  }

  return (
    <Layout data={{ oSeo: seoData }}>
      <section className={`${styles.formBlock} common-section pt-4 pb-3`}>
        <ATSAds />
        <Container>
          <Row>
            <Col lg={8} xxl={9}>
              <h1 className="mb-2 font-semi">Contact Us</h1>
              <p className="big-text">
                Hello Sports Lovers! We value your thoughts on how we can improve our match updates, cricket predictions, and address any
                queries you may have. Feel free to get in touch with us. Stay updated with the Latest Cricket Score, Daily Sports News, and
                Daily Sports Updates. We&apos;re here to make it simple and easy for you. Reach out and share your valuable feedback with us.
              </p>
              <Form autoComplete="off" className="mt-3 mt-md-4 mb-4 mb-lg-0" onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col md={6}>
                    <CustomFormGroup className={`${formStyles.formGroup}`} controlId="sName">
                      <CustomInput
                        className={`${formStyles.formControl} ${errors.sName && formStyles.hasError}`}
                        type="text"
                        name="sName"
                        placeholder={'Full Name'}
                        register={register('sName', {
                          required: validationErrors.required
                        })}
                      />
                      {errors.sName && (
                        <CustomFeedback message={errors.sName.message} type="invalid" className={`${formStyles.invalidFeedback}`} />
                      )}
                    </CustomFormGroup>
                  </Col>
                  <Col md={6}>
                    <CustomFormGroup className={`${formStyles.formGroup}`} controlId="sEmail">
                      <CustomInput
                        className={`${formStyles.formControl} ${errors.sEmail && formStyles.hasError}`}
                        type="text"
                        name="sEmail"
                        placeholder={'Email'}
                        register={register('sEmail', {
                          required: validationErrors.required,
                          pattern: { value: EMAIL, message: validationErrors.email },
                          validate: value => setValue('sEmail', value.toLowerCase())
                        })}
                      />
                      {errors.sEmail && (
                        <CustomFeedback message={errors.sEmail.message} type="invalid" className={`${formStyles.invalidFeedback}`} />
                      )}
                    </CustomFormGroup>
                  </Col>
                  <Col md={6}>
                    <CustomFormGroup className={`${formStyles.formGroup}`} controlId="sPhone">
                      <CustomInput
                        className={`${formStyles.formControl} ${errors.sPhone && formStyles.hasError}`}
                        type="number"
                        name="sPhone"
                        placeholder={'Phone Number'}
                        onKeyDown={e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                        register={register('sPhone', {
                          required: validationErrors.required,
                          pattern: { value: ONLY_NUMBER, message: validationErrors.number },
                          maxLength: { value: 10, message: validationErrors.number },
                          minLength: { value: 10, message: validationErrors.number }
                        })}
                      />
                      {errors.sPhone && (
                        <CustomFeedback message={errors.sPhone.message} type="invalid" className={`${formStyles.invalidFeedback}`} />
                      )}
                    </CustomFormGroup>
                  </Col>
                  <Col md={6}>
                    <CustomFormGroup className={`${formStyles.formGroup}`} controlId="company">
                      <CustomInput
                        className={`${formStyles.formControl}`}
                        placeholder={'Company'}
                        type="text"
                        name="company"
                        register={register('sCompany')}
                      />
                    </CustomFormGroup>
                  </Col>
                  <Col md={6}>
                    <CustomFormGroup className={`${formStyles.formGroup}`} controlId="city">
                      <CustomInput
                        className={`${formStyles.formControl}`}
                        placeholder={'City'}
                        type="text"
                        name="city"
                        register={register('sCity')}
                      />
                    </CustomFormGroup>
                  </Col>
                  {/* <Col md={6}>
                    <CustomFormGroup className={`${formStyles.formGroup}`} controlId="query">
                      <Controller
                        name="eQueryType"
                        control={control}
                        rules={{ required: validationErrors.required }}
                        render={({ field: { onChange, value = [] } }) => (
                          <CustomSelect
                            options={typeOfQueryOptions}
                            labelKey="sLabel"
                            valueKey="sValue"
                            placeholder={"Select Query"}
                            onChange={onChange}
                            name="eQueryType"
                            className={errors?.eQueryType && 'hasError'}
                            align={'end'}
                          />
                        )}
                      />
                      {errors.eQueryType && (
                        <CustomFeedback message={errors.eQueryType.message} type="invalid" className={`${formStyles.invalidFeedback}`} />
                      )}
                    </CustomFormGroup>
                  </Col> */}
                  <Col md={6}>
                    <CustomFormGroup className={`${formStyles.formGroup}`} controlId="sSubject">
                      <CustomInput
                        className={`${formStyles.formControl} ${errors.sSubject && formStyles.hasError}`}
                        type="text"
                        name="sSubject"
                        placeholder={'Subject'}
                        register={register('sSubject', {
                          required: validationErrors.required
                        })}
                      />
                      {errors.sSubject && (
                        <CustomFeedback message={errors.sSubject.message} type="invalid" className={`${formStyles.invalidFeedback}`} />
                      )}
                    </CustomFormGroup>
                  </Col>
                  <Col md={12}>
                    <CustomFormGroup className={`${formStyles.formGroup}`} controlId="sMessage">
                      <CustomInput
                        className={`${formStyles.formControl} ${formStyles.formTextarea} ${errors.sMessage && formStyles.hasError}`}
                        as="textarea"
                        name="sMessage"
                        placeholder={'Message'}
                        register={register('sMessage', {
                          required: validationErrors.required
                        })}
                      />
                      {errors.sMessage && (
                        <CustomFeedback message={errors.sMessage.message} type="invalid" className={`${formStyles.invalidFeedback}`} />
                      )}
                    </CustomFormGroup>
                  </Col>
                </Row>
                <Button className="theme-btn full-btn" variant="primary" type="submit" disabled={loading}>
                  Send message
                  {loading && <Spinner className="ms-2 align-middle" animation="border" />}
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  )
}
ContactUs.propTypes = {
  seoData: PropTypes.object
}
export default ContactUs

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=420')

    const queryGraphql = (await import('@shared/components/queryGraphql')).default
    const GET_SEO_DATA = (await import('@graphql/article/article.query')).GET_SEO_DATA
    const { checkRedirectionStatus } = await import('@shared-submodule/utils')
    const { allRoutes } = await import('@shared-submodule/sm-constants/allRoutes')
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: allRoutes.contactUs?.slice(1) } })
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    return {
      props: {
        seoData: seoData?.getSeoData
      }
    }
  } catch (e) {
    const handleApiError = (await import('@shared-submodule/utils')).handleApiError
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
